// extracted by mini-css-extract-plugin
export default {"buttons":"DeleteAdminModal_buttons__VtdXT"};